//#region src/wayfinder_hotspot_variant.ts
let WayfinderHotspotVariant = /* @__PURE__ */ function(WayfinderHotspotVariant) {
	WayfinderHotspotVariant["Kiosk"] = "kiosk";
	WayfinderHotspotVariant["Other"] = "other";
	return WayfinderHotspotVariant;
}({});
//#endregion
export { WayfinderHotspotVariant };

//# sourceMappingURL=wayfinder_hotspot_variant.js.map